module.exports = __webpack_public_path__ + "static/media/Serie-PG.8b063d0a.pdf";